<template>
  <div
    v-if="!isWC()"
    :style="{ 'background-image': 'url(' + store.ProfileImage + ')' }"
    class="banner text-white position-relative"
  >
    <div class="company-details">
      <router-link :to="geyHomePageUrl">
        <img :src="store.Logo" />
      </router-link>
      <h2 v-show="store.StoreTitle">{{ store.StoreTitle }}</h2>
      <h5 v-show="!isGift">{{ store.Name }}</h5>
      <h5 v-if="store.Location">{{ store.Location.Address }}</h5>
      <h5
        v-if="store.Location"
      >{{( store.Location.Suburb||"") + " " + (store.Location.State ||"")+ " " + (store.Location.Postcode||"") }}</h5>
      <div v-if="!isGift">
        <h6 v-if="opening">
          {{ $t('message.open') }}
          <span>{{ opening.openTime }}</span> to
          <span>{{ opening.closeTime }}</span>
        </h6>
        <h6 v-else>{{ $t('message.closedToday') }}</h6>
      </div>
    </div>
  </div>
</template>

<script>
import { getStore } from "../../../api/services/storeService.js";
import { operatingHours } from "../../../api/helpers/datetimeHelper.js";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "ShopHeader",
  props: {
    storeId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      store: Object
    };
  },
  computed: {
    ...mapGetters(["isGift"]),
    opening() {
      if (this.store.OperatingHours) {
        return operatingHours(this.store);
      }
      return "";
    },
    geyHomePageUrl() {
      return this.isGift
        ? "/store/" + this.store.ID + "/giftcards"
        : "/store/" + this.store.ID;
    }
  },
  mounted() {
    let that = this;
    getStore(this.storeId).onSnapshot(
      function(doc) {
        if (doc.exists) {
          that.store = doc.data();
        }
      },
      function(reason) {
        that.insertErrorlog([reason.code, reason.message, "/shopheader"]);
        that.redirectToErrorPage();
      }
    );
  },
  methods: {
    ...mapActions(["insertErrorlog", "redirectToErrorPage"])
  }
};
</script>
